import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from '../../hooks/auth';
import { useLoader } from '../../hooks/loading';
import { createPhatoBusinessAccessContext } from '../SignIn/phato-access-context';

export const useSignInBusiness = () => {
  const [signInData, setSignInData] = useState({ cnpj: '', password: '' });
  const history = useHistory();
  const { showLoader, hideLoader } = useLoader();
  const {
    loadStorageData,
    signInPhato,
    signInLaureano,
    signInLaureanoSoul,
    signInHnsn,
    setPhatoAccess,
  } = useAuth();

  async function handleSignIn() {
    if (!signInData.cnpj || !signInData.password) {
      toast.warning('Preencha todos os campos');
      return;
    }

    const credentials = {
      login: signInData.cnpj,
      password: signInData.password,
      isMedico: 'false',
      isBusiness: 'true',
    };

    showLoader();
    try {
      const results = await Promise.allSettled([
        signInPhato(credentials),
        signInLaureano(credentials),
        signInLaureanoSoul(credentials),
        signInHnsn(credentials),
      ]);

      if (results.every((result) => result.status === 'rejected')) {
        sessionStorage.removeItem('@cedapp:isBusiness');
        toast.error(
          'Erro ao fazer login. Verifique suas credenciais e tente novamente.',
        );
        return;
      }

      const phatoOk = results[0].status === 'fulfilled';
      if (phatoOk) {
        await setPhatoAccess(
          createPhatoBusinessAccessContext(signInData.cnpj),
        );
      }

      sessionStorage.setItem('@cedapp:isBusiness', 'true');
      await loadStorageData();
      history.push('/home');
    } finally {
      hideLoader();
    }
  }

  return { handleSignIn, signInData, setSignInData };
};
